import React from 'react';
import { motion } from 'framer-motion';

/**
 * Reusable Section component for consistent layout and spacing
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Section content
 * @param {string} props.id - Section ID for navigation
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.background - Background variant: 'default', 'coffee', 'cream', 'pattern'
 * @param {boolean} props.fullHeight - Make section full viewport height
 * @param {Object} props.animation - Framer Motion animation props
 */
const Section = ({
  children,
  id,
  className = '',
  background = 'default',
  fullHeight = false,
  animation = {},
  ...props
}) => {
  const baseClasses = 'section-padding';
  
  const backgroundClasses = {
    default: 'bg-coffee-50',
    coffee: 'bg-gradient-to-br from-coffee-100 to-coffee-200',
    cream: 'bg-gradient-to-br from-cream-50 to-cream-100',
    pattern: 'bg-coffee-50 coffee-pattern'
  };
  
  const heightClasses = fullHeight ? 'min-h-screen flex items-center' : '';
  
  const sectionClasses = `${baseClasses} ${backgroundClasses[background]} ${heightClasses} ${className}`;
  
  const defaultAnimation = {
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    viewport: { once: true, margin: '-100px' },
    transition: { duration: 0.6 }
  };
  
  const finalAnimation = { ...defaultAnimation, ...animation };
  
  return (
    <motion.section
      id={id}
      className={sectionClasses}
      {...finalAnimation}
      {...props}
    >
      <div className="container-custom">
        {children}
      </div>
    </motion.section>
  );
};

export default Section;